import React from 'react';
import {
  Grid,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  Paper,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  TableBody,
  Link,
  Button,
  TableFooter,
  TablePagination,
  Input,
  InputAdornment,
  FormHelperText,
  TextField,
  Typography,
} from '@material-ui/core';
import {
  AssessmentOutlined as AssessmentOutlinedIcon,
} from '@material-ui/icons';

import { Helmet } from 'react-helmet';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

import Commify from 'comma-number';
import { isMobile } from 'react-device-detect';
import Moment from 'moment';

import APIServer from '../../config/server.conf.json';
import moment from 'moment';
import 'moment/locale/ko';

export default class StockSideway extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: {
        datelist: true,
        stocklist: true,
      },
      selected_market: 'KOSPI',
      selected_days: 90,
      threshold: 3,
      pagination: {
        page: 1,
        limit: 25
      },
      pickDate: {
        startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
      }
    }
  }

  loadSidewayData = () => {
    if(this.state.selected_market === 'ALL') {
      return fetch(`${APIServer.baseUrl}/api/v1/stock/sideway?days=${this.state.selected_days}&threshold=${this.state.threshold}&page=${this.state.pagination.page}&limit=${this.state.pagination.limit}`);
    }

    return fetch(`${APIServer.baseUrl}/api/v1/stock/sideway?market=${this.state.selected_market}&days=${this.state.selected_days}&threshold=${this.state.threshold}&page=${this.state.pagination.page}&limit=${this.state.pagination.limit}`);
  }

  componentDidMount() {
    this.loadSidewayData()
      .then((resp) => resp.json())
      .then((resp) => {
        if(resp.status === 200) {
          this.setState({
            ...this.state,
            isLoading: {
              ...this.state.isLoading,
              stocklist: false,
            },
            stocklist: resp.data
          });
        }
      });
  }

  // componentWillUnmount() {
  //   // clearInterval(this.realtime_timer);
  // }

  handlePickDate = (m, target) => {
    if(target === 'start') {
      this.setState({
        ...this.state,
        pickDate: {
          ...this.state.pickDate,
          startDate: m.format(m._f)
        }
      });
    } else {
      this.setState({
        ...this.state,
        pickDate: {
          ...this.state.pickDate,
          endDate: m.format(m._f)
        }
      });
    }
    
  }

  handleMarketOnChange = (e) => {
    this.setState({
      ...this.state,
      selected_market: e.target.value
    });
  }

  handleDaysOnChange = (e) => {
    this.setState({
      ...this.state,
      selected_days: e.target.value
    });
  }

  handleChangeThreshold = (e) => {
    this.setState({
      ...this.state,
      threshold: e.target.value
    });
  }

  handleLoadOnClick = (e) => {
    this.setState({
      ...this.state,
      isLoading: {
        ...this.state.isLoading,
        stocklist: true,
      }
    }, () => {
      this.loadSidewayData()
        .then((resp) => resp.json())
        .then((resp) => {
          if(resp.status === 200) {
            this.setState({
              ...this.state,
              isLoading: {
                ...this.state.isLoading,
                stocklist: false,
              },
              stocklist: resp.data
            });
          }
        });
    });
  }

  handleChangePage = (event, newPage) => {
    this.setState({
      ...this.state,
      pagination: {
        ...this.state.pagination,
        page: newPage + 1,
      }
    }, () => {
      this.loadSidewayData()
        .then((resp) => resp.json())
        .then((resp) => {
          if(resp.status === 200) {
            this.setState({
              ...this.state,
              isLoading: {
                ...this.state.isLoading,
                stocklist: false,
              },
              stocklist: resp.data
            });
          }
        });
    });
  };

  handleChangeRowsPerPage = event => {
    this.setState({
      ...this.state,
      pagination: {
        page: 1,
        limit: parseInt(event.target.value, 10),
      }
    }, () => {
      this.loadSidewayData()
        .then((resp) => resp.json())
        .then((resp) => {
          if(resp.status === 200) {
            this.setState({
              ...this.state,
              isLoading: {
                ...this.state.isLoading,
                stocklist: false,
              },
              stocklist: resp.data
            });
          }
        });
    });
  };

  render() {
    return (
      <Grid container style={{ padding: 10, minHeight: 300 }} spacing={3}>
        <Helmet
          title="주식정보 - 횡보"
          meta={[
            { name: "description", content: "주식정보 - 횡보" },
            { name: "keywords", content: "toolbox, tbx, 툴박스, stock, 주식, 주식정보, ,횡보" },
            { property: "og:title", content: "주식정보 - 횡보 - TBX" },
            { property: "og:description", content: "주식정보 - 횡보 - TBX" },
            { property: "og:title", content: "주식정보 - 횡보 - TBX" },
          ]}
        />
        <Grid item xs={12}>
          {/* <MuiPickersUtilsProvider libInstance={Moment} utils={MomentUtils}>
            <KeyboardDatePicker
              disableFuture
              autoOk={true}
              label="Start Date"
              format="YYYY-MM-DD"
              maxDate={this.state.pickDate.endDate}
              value={this.state.pickDate.startDate}
              onChange={m => this.handlePickDate(m, 'start')}
              style={{ margin: 10, maxWidth: 150 }}
            />
          </MuiPickersUtilsProvider>
          <MuiPickersUtilsProvider libInstance={Moment} utils={MomentUtils}>
            <KeyboardDatePicker
              disableFuture
              autoOk={true}
              label="End Date"
              format="YYYY-MM-DD"
              minDate={this.state.pickDate.startDate}
              value={this.state.pickDate.endDate}
              onChange={m => this.handlePickDate(m, 'end')}
              style={{ margin: 10, maxWidth: 150 }}
            />
          </MuiPickersUtilsProvider> */}
          <FormControl style={{ margin: 10, minWidth: 100 }}>
            <InputLabel shrink>
              Market
            </InputLabel>
            <Select
              value={this.state.selected_market}
              onChange={this.handleMarketOnChange}
            >
              <MenuItem key="ALL" value="ALL">
                All
              </MenuItem>
              <MenuItem key="KOSPI" value="KOSPI">
                KOSPI
              </MenuItem>
              <MenuItem key="KOSDAQ" value="KOSDAQ">
                KOSDAQ
              </MenuItem>
            </Select>
          </FormControl>
          <FormControl style={{ margin: 10, minWidth: 100 }}>
            <InputLabel shrink>
              기준일
            </InputLabel>
            <Select
              value={this.state.selected_days}
              onChange={this.handleDaysOnChange}
            >
              <MenuItem key="20" value="20">
                20
              </MenuItem>
              <MenuItem key="30" value="30">
                30
              </MenuItem>
              <MenuItem key="60" value="60">
                60
              </MenuItem>
              <MenuItem key="90" value="90">
                90
              </MenuItem>
              <MenuItem key="120" value="120">
                120
              </MenuItem>
              <MenuItem key="200" value="200">
                200
              </MenuItem>
              <MenuItem key="270" value="270">
                270
              </MenuItem>
            </Select>
          </FormControl>
          <FormControl style={{ margin: 10, minWidth: 75 }}>
            <TextField
              style={{ width: 75 }}
              label="기준 %"
              type="number"
              value={this.state.threshold}
              onChange={this.handleChangeThreshold}
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }}
            />
            {/* <Input
              value={this.state.threshold}
              onChange={this.handleChangeThreshold}
              endAdornment={<InputAdornment position="end">%</InputAdornment>}
              type="number"
            />
            <FormHelperText>Weight</FormHelperText> */}
          </FormControl>
          <FormControl style={{ margin: 10 }}>
            <Button
              variant="contained"
              color="primary"
              disableElevation
              style={{ margin: 10 }}
              onClick={this.handleLoadOnClick}
            >
              조회
            </Button>
          </FormControl>
        </Grid>
        {this.state.isLoading.stocklist &&
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <CircularProgress color="secondary" size={50} />
        </Grid>}
        {!this.state.isLoading.stocklist &&
        <Grid item xs={12}>
          <Typography variant="subtitle2" align="right">
            기간: {this.state.stocklist.start_date} ~ {this.state.stocklist.end_date}
          </Typography>
        </Grid>}
        {!this.state.isLoading.stocklist &&
        <Grid item xs={12}>
          <Paper variant="outlined">
            <TableContainer>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell key="head-num">
                      {/* <TableSortLabel> */}
                        #
                      {/* </TableSortLabel> */}
                    </TableCell>
                    <TableCell key="head-name">
                      {/* <TableSortLabel> */}
                        종목명
                      {/* </TableSortLabel> */}
                    </TableCell>
                    <TableCell key="head-market">
                      {/* <TableSortLabel> */}
                        시장
                      {/* </TableSortLabel> */}
                    </TableCell>
                    <TableCell key="head-tradePrice">
                      {/* <TableSortLabel> */}
                        기간중 저가
                      {/* </TableSortLabel> */}
                    </TableCell>
                    <TableCell key="head-latest_date">
                      {/* <TableSortLabel> */}
                        기간중 고가
                      {/* </TableSortLabel> */}
                    </TableCell>
                    <TableCell key="head-changeRate">
                      {/* <TableSortLabel> */}
                        등락률
                      {/* </TableSortLabel> */}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.stocklist.rows.length === 0 &&
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        align="center"
                      >
                        No Data.
                      </TableCell>
                    </TableRow>
                  }
                  {this.state.stocklist.rows.map((e, i) => {
                    return (
                      <TableRow
                        key={i}
                        hover
                      >
                        <TableCell>
                          {((this.state.pagination.page - 1) * this.state.pagination.limit) + i + 1}
                        </TableCell>
                        <TableCell>
                          {/* <Link href={isMobile ? `https://m.finance.daum.net/quotes/${e.symbol_code}/home`:`https://finance.daum.net/quotes/${e.symbol_code}`} target="new">
                            {e.name}
                          </Link> */}
                          <Link href={`https://finance.naver.com/item/main.nhn?code=${e.symbol_code.substr(1)}`} target="new">
                            {e.name}
                          </Link>
                        </TableCell>
                        <TableCell>
                          {e.market}
                        </TableCell>
                        <TableCell>
                          {Commify(e.min_value)}원
                        </TableCell>
                        <TableCell>
                          {Commify(e.max_value)}원
                        </TableCell>
                        <TableCell>
                          <span style={{
                            color: e.rate < 0 ? 'blue':(e.rate === 0 ? 'black':'red')
                          }}>
                            {e.rate < 0 ? '-':(e.rate === 0 ? '':'+')}{(e.rate * 100).toFixed(2)}%
                          </span>
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[ 10, 25, 50, 100 ]}
                      rowsPerPage={this.state.pagination.limit}
                      count={this.state.stocklist.total}
                      page={this.state.pagination.page-1}
                      onChangePage={this.handleChangePage}
                      onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>}
      </Grid>
    );
  }
}